import { ConsoleLogger } from '@nextgen-web-framework/core';
import { OtpVerificationProps } from '../types/propTypes';

export const OtpVerification = (props: OtpVerificationProps) => {
  ConsoleLogger.info(props);
  return <div>propertyTypeKey</div>;
};

export default OtpVerification;
